module.exports = __webpack_public_path__ + "img/bg_people_home_02_big_1.e013429b.png";